"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoType = void 0;
var PhotoType;
(function (PhotoType) {
    PhotoType["SmartMeter"] = "smartMeter";
    PhotoType["FuseBox"] = "fusebox";
    PhotoType["GroupBox"] = "groupbox";
    PhotoType["InstallationSite"] = "installationSite";
    PhotoType["CrawlSpace"] = "crawlSpace";
    PhotoType["DiggingGroundType"] = "digginggroundtype";
    PhotoType["DiggingGroundType2"] = "digginggroundtype2";
})(PhotoType || (exports.PhotoType = PhotoType = {}));
